<template>
    <li class="expandable">
        <div class="label" @click="expanded = !expanded;">
            <label>{{ name }}</label>
            <!--
                we can't put dynamic class on font-awesome because the <i> is coverted to <svg> and that <svg> is not observed.
                Instead it is wrapped into a pointless <div> with a key that change whenever the class should change
                to force the recreation of the <svg>.
            -->
            <div :key="expanded"><i class="fa" :class="expanded ? 'fa-chevron-down' : 'fa-chevron-up'"></i></div>
        </div>
        <hr />

        <slot v-if="expanded"></slot>
    </li>
</template>

<script>
export default {
    props: {
        name: {
            type: String,
            required: true
        }
    },
    data: () => ({ expanded: true })
};
</script>

<style scoped lang="scss">
li.expandable {
    list-style-type: none;
    padding-top: 20px;

    .label {
        display: flex;
        justify-content: space-between;

        label {
            text-transform: uppercase;
            font-family: "Oswald";
            display: block;
        }
    }
    hr {
        background-color: black;
        height: 3px;
        margin: 0;
        border-radius: 3px;
    }
}
</style>



// WEBPACK FOOTER //
// expandable.vue?272f4025